import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { capitalize } from 'lodash';
import { useAnalytics } from 'use-analytics';
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from 'react-icons/md';
import { SearchModes } from '../../constants';

const Pagination = ({
  page, pageSize, totalCount, onPrevPageClick, onNextPageClick, resultsLabel,
  searchMode,
}) => {
  const { track } = useAnalytics();
  const { travelAgency } = useSelector((store) => store.user);
  const doHidePostSearchFilters = searchMode === SearchModes.FLIGHT
    && travelAgency && travelAgency.settings
    && travelAgency.settings.doHidePostSearchFilters;
  const doShowManyLabel = useMemo(() => doHidePostSearchFilters && totalCount > pageSize,
    [doHidePostSearchFilters, pageSize, totalCount]);

  const handlePrevPageClick = () => {
    onPrevPageClick();
    track('pagination.handlePrevPageClick', {
      page, pageSize, totalCount, resultsLabel,
    });
  };

  const handleNextPageClick = () => {
    onNextPageClick();
    track('pagination.handleNextPageClick', {
      page, pageSize, totalCount, resultsLabel,
    });
  };

  return (
    <div className="pt-2 col-span-2 flex whitespace-no-wrap relative z-10">
      <div>
        <span className="text-gray-600">Showing: </span>
        <span>
          <span className="font-bold">{((page - 1) * pageSize) + 1}</span>
          {' '}
          to
          <span className="font-bold">
            {' '}
            {page * pageSize > totalCount
              ? (page - 1) * pageSize + (totalCount % pageSize)
              : page * pageSize}
          </span>
          {' '}
          of
          <span className="font-bold">
            {' '}
            {doShowManyLabel ? 'Many' : totalCount}
          </span>
          {' '}
          {capitalize(resultsLabel)}
        </span>
      </div>
      <div className="flex text-3xl -mr-3">
        <div>
          <MdKeyboardArrowLeft onClick={handlePrevPageClick} className="cursor-pointer" />
        </div>
        <div>
          <MdKeyboardArrowRight onClick={handleNextPageClick} className="cursor-pointer" />
        </div>
      </div>
    </div>
  );
};

Pagination.propTypes = {
  page: PropTypes.number,
  pageSize: PropTypes.number,
  totalCount: PropTypes.number,
  onPrevPageClick: PropTypes.func.isRequired,
  onNextPageClick: PropTypes.func.isRequired,
  resultsLabel: PropTypes.string.isRequired,
  searchMode: PropTypes.string,
};

Pagination.defaultProps = {
  page: null,
  pageSize: null,
  totalCount: null,
  searchMode: undefined,
};

export default Pagination;
